// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"196032b2620ee2fa6d4c","293":"aae34b814bbde4985e88","518":"f25eeb5bc0f2d9254cc4","779":"989a7f5bfa7e37623235"}[chunkId] + ".js";
};